import React, { FunctionComponent } from 'react'
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

export const SlidersIcon: FunctionComponent<SlidersIconProps> = ({ size = 24, color }) => {
  const { colors } = useTheme()

  return (
    <Svg width={size} height={size} viewBox='0 0 40 40' fill='none' testID={tID('SlidersIcon')}>
      <Defs>
        <ClipPath id='clip0_3947_69536'>
          <Rect width='20' height='20' fill='white' transform='translate(10 30) rotate(-90)' />
        </ClipPath>
      </Defs>
      <G clipPath='url(#clip0_3947_69536)'>
        <Path
          d='M27.5001 26.6666L21.6667 26.6666'
          stroke={color ?? colors.iconDefault}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <Path
          d='M18.3333 26.6666L12.5 26.6666'
          stroke={color ?? colors.iconDefault}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <Path
          d='M27.5 20L20 20'
          stroke={color ?? colors.iconDefault}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <Path
          d='M16.6667 20L12.5 20'
          stroke={color ?? colors.iconDefault}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <Path
          d='M27.4999 13.3334L23.3333 13.3334'
          stroke={color ?? colors.iconDefault}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <Path
          d='M20 13.3334L12.5 13.3334'
          stroke={color ?? colors.iconDefault}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <Path
          d='M21.6667 29.1666L21.6667 24.1666'
          stroke={color ?? colors.iconDefault}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <Path
          d='M16.6667 22.5L16.6667 17.5'
          stroke={color ?? colors.iconDefault}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <Path
          d='M23.3333 15.8334L23.3333 10.8334'
          stroke={color ?? colors.iconDefault}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </G>
    </Svg>
  )
}

type SlidersIconProps = {
  size?: string | number
  color?: string
}
